let info = {
  name: "André Oliveira",
  logo_name: "André",
  flat_picture: require("./src/assets/potrait.png"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false,
    },
  },
  description:
    "I’m a Master’s student in Software Engineering at the University of Aveiro, focused on building scalable backend and IoT data systems. I work primarily with Python, Java, and C/C++, and have hands-on experience designing REST APIs, managing data pipelines, and deploying cloud-native applications using FastAPI, Docker, and Kubernetes.<br></br>I’ve built real-world systems integrating MQTT and Kafka for smart city IoT projects, leveraging PostgreSQL, MongoDB, and Redis for reliable data handling. I’m also comfortable across the full development lifecycle, from designing microservices to CI/CD automation.<br></br>Beyond code, I value clean architecture, measurable impact, and collaboration. If you’re building something ambitious and care about scalability and data flow, let’s talk.",
  links: {
    linkedin: "https://www.linkedin.com/in/andré-oliveira-72661627b/",
    github: "https://github.com/andreaoliveira9",
    cv: "/CV.pdf",
  },
  education: [
    {
      name: "University of Aveiro",
      place: "Aveiro, Portugal",
      date: "Sep, 2024 - Present",
      degree: "Master's in Software Engineering",
      gpa: "17.50/20.00",
      description:
        "Currently pursuing a Master's degree in Software Engineering at the University of Aveiro, with a focus on software development and computer science.",
      skills: [],
    },
    {
      name: "University of Aveiro",
      place: "Aveiro, Portugal",
      date: "Sep, 2021 - Jun, 2024",
      degree: "Bachelor's in Software Engineering",
      gpa: "16.37/20.00",
      description:
        "Currently pursuing a Bachelor's degree in Software Engineering at the University of Aveiro, with a focus on software development and computer science.",
      skills: [
        "Algorithms",
        "Data Structures",
        "Databases",
        "Web Development",
        "Computer Networks",
        "Operating Systems",
        "Computer Architecture",
        "Artificial Intelligence",
        "Machine Learning",
        "Distributed Systems",
        "Object-Oriented Programming",
        "Software Testing",
        "Software Quality",
        "Software Patterns",
        "Compilers",
        "UI/UX",
        "Security",
      ],
    },
    {
      name: "Dr. Mario Sacramento Secondary School",
      place: "Aveiro, Portugal",
      date: "Sep, 2018 - Jun, 2021",
      degree: "High School",
      gpa: "18.6/20.0",
      description:
        "Completed my high school education with a focus on the sciences.",
      skills: [
        "Physics",
        "Chemistry",
        "Mathematics",
        "Biology",
        "Geology",
        "Spanish",
        "Portuguese",
        "Physical Education",
        "Psychology",
        "Filosophy",
      ],
    },
  ],
  experience: [
    {
      name: "Researcher",
      place: "Instituto de Telecomunicações",
      date: "September 2024 – Current",
      location: "Aveiro, Portugal",
      description:
        "Design and implement end-to-end data pipelines for Smart City use cases (Smart Crosswalks, Smart Bikes, Mobility Safety), integrating real-time IoT sensor data.Enhance the data platform’s architecture by improving ingestion, processing and exposure layers using microservices and FIWARE-based technologies. Manage service orchestration and data flow integration across MQTT, Kafka, processing services, and Orion Context Broker using Docker and Kubernetes. Collaborate with research teams at the Instituto de Telecomunicações to develop scalable multi-tenant data models and validate deployments within the Aveiro Tech City Living Lab.",
      skills: [
        "IoT",
        "Kafka",
        "MQTT",
        "Docker",
        "Kubernetes",
        "FIWARE",
        "Python",
      ],
    },
    {
      name: "Backend Software Developer",
      place: "Núcleo de Estudantes de Informática",
      date: "September 2023 – September 2024",
      location: "Aveiro, Portugal",
      description:
        "Developed and integrated new database-driven features and REST APIs for NEI’s web platform (nei.web.ua.pt). Leveraged FastAPI (Python) and PostgreSQL to design scalable backend services and ensure system reliability.",
      skills: ["FastAPI", "Python", "PostgreSQL"],
    },
  ],
  skills: [
    {
      title: "languages",
      info: ["Python", "C", "C++", "Java", "JavaScript", "Bash", "SQL"],
      icon: "fa fa-code",
    },
    {
      title: "frameworks & libraries",
      info: [
        "FastAPI",
        "Flask",
        "Django",
        "Spring Boot",
        "React",
        "TensorFlow",
        "PyTorch",
        "NumPy",
        "Scikit-learn",
        "Selenium",
      ],
      icon: "fa fa-cubes",
    },
    {
      title: "databases",
      info: [
        "PostgreSQL",
        "MongoDB",
        "Redis",
        "Cassandra",
        "Microsoft SQL Server",
        "Neo4j",
      ],
      icon: "fa fa-database",
    },
    {
      title: "message brokers & streaming",
      info: ["Kafka", "RabbitMQ", "Mosquitto (MQTT)"],
      icon: "fa fa-project-diagram",
    },
    {
      title: "devops & tools",
      info: [
        "Docker",
        "Kubernetes",
        "Git",
        "Maven",
        "GitHub Actions",
        "GitLab CI/CD",
        "SonarQube",
        "Terraform",
        "Jira",
      ],
      icon: "fas fa-tools",
    },
    {
      title: "cloud & hosting",
      info: ["AWS", "Firebase", "Nginx"],
      icon: "fas fa-cloud",
    },
    {
      title: "other",
      info: ["Elasticsearch", "JWT", "macOS"],
      icon: "fa fa-ellipsis-h",
    },
  ],
  portfolio: [
    {
      name: "TrailBlazer",
      pictures: [
        {
          img: require("./src/assets/portfolio/trailblazer/LogoBlack.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/RecommendationAssessment.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/HomePage.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/OfferList.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/BasePage.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/Payment.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/Review.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/MyOffers.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/MyTransactions.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/Dashboard.png"),
        },
        {
          img: require("./src/assets/portfolio/trailblazer/Analysis.png"),
        },
      ],
      technologies: [
        "TypeScript",
        "PostgreSQL",
        "MongoDB",
        "React",
        "RabbitMQ",
        "Docker",
        "Firebase",
        "fastAPI",
        "NGINX",
        "Elasitcsearch",
        "Kibana",
        "JIRA",
        "SonarCloud",
      ],
      category: "Website",
      date: "Feb, 2024 - Jun, 2024",
      github: "https://github.com/PI-Trailblazer/deployement",
      visit: "https://pi-trailblazer.github.io/microsite/",
      description:
        "Trailblazer is a groundbreaking initiative aimed at revitalizing the tourism industry through the integration of Machine Learning (ML) and Natural Language Processing (NLP) technologies. By developing an advanced Destination Management System (DMS), Trailblazer seeks to empower Destination Management Organizations (DMOs) with predictive analytics to foresee trends and make informed decisions in infrastructure, marketing, and sustainability practices. The system analyzes tourists' feedback across various platforms to derive insights into preferences and sentiments, enhancing service quality and personalizing travel experiences. At its core, Trailblazer features a personalized recommendation engine that curates activities tailored to individual interests, fostering a seamless exploration of new experiences while enabling providers to effectively showcase their offerings. This multifaceted approach benefits tourists with customized travel suggestions, provides attraction providers with valuable market insights, and equips DMOs with sophisticated analytical tools for sustainable tourism development.",
    },
    {
      name: "GateMate",
      pictures: [
        {
          img: require("./src/assets/portfolio/gatemate/logo.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/HomePage.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/Login.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/AllFlights.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/FlightData.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/BuyFlight.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/MyTickets.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/CheckinOnline.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/Map.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/FlightLiveData.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/FlightsAdmin.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/FlightInfoAdmin.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/CheckinManual.png"),
        },
        {
          img: require("./src/assets/portfolio/gatemate/Display.png"),
        },
      ],
      technologies: [
        "React",
        "NGINX",
        "Docker",
        "Spring Boot",
        "MySQL",
        "RabbitMQ",
        "SonarCloud",
        "JIRA",
      ],
      category: "Website",
      date: "Apr, 2024 - Jun, 2024",
      github: "https://github.com/GateMate-TQS/GateMate",
      description:
        "GateMate is a flight booking and management platform designed to simplify and enhance the travel experience for users utilizing air travel services. It will be used by travelers to perform various flight-related operations, such as ticket booking, online check-in, and accessing real-time flight information. The high-level problem our system aims to solve is the complexity and lack of convenience often associated with air travel. Currently, travelers frequently need to deal with multiple websites and apps from different airlines to make their reservations, check in, and obtain information about their flights. This can be confusing and time-consuming, resulting in a frustrating travel experience. GateMate was conceived to address this problem by offering a comprehensive and centralized solution for all users' flight booking and management needs. With an intuitive and user-friendly interface, travelers can complete all necessary steps before their trip, from booking tickets to checking in and accessing updated information about their flights, all in one place. Initially, we planned to include extensive integration with various airlines, providing users with a wide range of flight options. However, due to the complexity and challenges associated with this approach, we decided to focus on a few major airlines for the initial launch of the system, with plans to expand and include more airlines in the future. This system differentiates itself from similar products through its integrated, user-centric approach. By consolidating all flight-related functionalities into a single platform, GateMate offers users a more convenient and efficient experience, making air travel more accessible and enjoyable.",
    },
    {
      name: "DigDug AI Agent",
      pictures: [
        {
          img: require("./src/assets/portfolio/digdug/logo.jpg"),
        },
      ],
      technologies: ["Python", "Search Algorithms", "Artificial Intelligence"],
      category: "Artificial Intelligence",
      github: "https://github.com/andreaoliveira9/Projeto-IA",
      date: "Sep, 2023 - Jan, 2024",
      description:
        "Developed an Autonomous Agent for the game Dig Dug in Python using search algorithms to navigate with the agent around the map.",
    },
    {
      name: "Distributed Music Editor",
      pictures: [
        {
          img: require("./src/assets/portfolio/distributedmusiceditor/logo.png"),
        },
      ],
      technologies: ["Python", "Redis", "Celery", "Socket"],
      category: "Distributed Systems",
      github: "https://github.com/andreaoliveira9/Projeto-CD",
      date: "May, 2023 - Jun, 2023",
      description:
        "Developed a distributed music editor using Python. The system allows multiple workers to edit the same music file simultaneously. The system uses Redis as a database and Celery for task management. The system is composed of a server and multiple workers.",
    },
    {
      name: "DETI Store",
      pictures: [
        {
          img: require("./src/assets/portfolio/detistore/xss_search-1.jpeg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/recaptcha.jpeg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/code_expriration.png"),
        },
        {
          img: require("./src/assets/portfolio/detistore/email_code.png"),
        },
        {
          img: require("./src/assets/portfolio/detistore/enter_code.png"),
        },
        {
          img: require("./src/assets/portfolio/detistore/email_profile_change.jpg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/xss_search_fixed-1.jpeg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/xss_comments-1.jpeg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/xss_comments-2221.jpeg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/sql_injection_wishlist-1.jpeg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/InjectionCartSafe.jpeg"),
        },
        {
          img: require("./src/assets/portfolio/detistore/certificate.jpeg"),
        },
      ],
      technologies: [
        "Flask",
        "SQLAlchemy",
        "SQLite",
        "HTML",
        "CSS",
        "Bootstrap",
        "NGINX",
      ],
      category: "Website",
      github: "https://github.com/andreaoliveira9/Projeto-SIO-2",
      date: "Oct, 2023 - Dec, 2023",
      description:
        "Developed a simple DETI store using Flask. Implemented with high security standards like OAuth2, database encryption, recaptcha, and more.",
    },
  ],
};

export default info;
